import { Editor } from "@tiptap/react";
import { EditorMatch, MatchesEntity } from "../../model/languagetool/types";
import "./SuggestionBox.scss"
import { FloatingDialogComponent } from "./FloatingDialogComponent";
import { getMaxSuggestions } from "../../model/languagetool/MatchesRepository";
import { DisableRule } from "./DisableRule"
import { Mode } from "../../config/types";

interface SuggestionBoxProps {
    editor : Editor
    currentMatch: EditorMatch
    replace: (arg0: string) => void
    clean: () => void
    mode: Mode
}

const SuggestionBox = ({editor, mode, currentMatch, replace, clean} : SuggestionBoxProps) => {

    if (!editor) {
        return <></>
    }

    return (      
        <FloatingDialogComponent
            className="match-popup"
            updateDelay={50}
            tippyOptions={{ duration: 150, arrow: true, maxWidth: 400 }}
            editor={editor}
            shouldShow={mode === "SpellCheck" && currentMatch.isValid()}
            matchId={currentMatch.id}
        >
            <div role="tooltip">
                <PopupContent currentMatch={currentMatch} replace={replace} clean={clean} />
            </div>
      </FloatingDialogComponent>
      )
}

const MoreInfo = ({ url } : { url: string }) => {
    return (<div className="match-popup-action match-popup-more-info">
        <span className="fa fa-info"></span>
        <a href={url} target="_moreInfo" className="match-popup-more-info-link">Més informació</a>
    </div>)
}

type PopupContentProps = { 
    currentMatch: EditorMatch
    replace: (s: string) => void
    clean: () => void
}

const PopupContent = ({ currentMatch, replace, clean } : PopupContentProps) => {
    
    if (!currentMatch.isValid() || currentMatch.segment?.segmentType !== "SpellCheck" ) {
        return <></>
    }

    const match = currentMatch.segment as MatchesEntity

    const url = match.rule.urls?.length ? match.rule.urls[0].value : false;


    const maxSuggestions = getMaxSuggestions(match.rule)
    
    return(
        <>
            <div className="match-popup">
            
            <div className="match-popup-description">{match.message}</div>

            <div className="match-popup-actions">
                {match.replacements?.slice(0, maxSuggestions).map((replacement) => {
                return (
                    <button
                        key={`${currentMatch.id}-${replacement.value}`}
                        className="match-popup-action"
                        data-replacement={replacement.value}
                        onClick={() => { 
                            replace(replacement.value) 
                        }}
                    >
                    {replacement.value}
                    </button>
                )
                })}
            </div>
            <div>
                { url && <MoreInfo url={url} /> }
                <DisableRule currentMatchId={currentMatch.id} clean={clean} />
            </div>
            </div>
            <div className="popup-arrow" data-popper-arrow></div>
        </>
    )
}

export { SuggestionBox }